
class SocialPanel {

	// Facebook
	// Twitter
	// LinkedIn
	// Google+
	// Pinterest

	constructor( elem ){

		this.elem = elem;
		this.w = null;

		var lang = $('html:first').attr('lang');

		var twUsername = ($('meta[name="twitter:site"]').attr('content') || "").replace("@", "");

		this.meta = {
			title: encodeURI($('meta[property="og:title"]').attr('content')),
			description: encodeURI($('meta[property="og:description"]').attr('content')),
			currentUrl: encodeURI(window.location.href),
			language: lang,
			twitterUsername: encodeURI(twUsername)
		}

		this.meta.oneliner = this.meta.description;

		this.bind();
	}

	bind(){
		this.elem.on('click', '.button', (e) => {
			e.preventDefault();
			var c = this.getTargetSocialClass(e.currentTarget);

			switch(c) {
				case "facebook":
					this.shareFacebook();
					break;
				case "twitter-x":
					this.shareTwitterX()
					break;
				case "linkedin":
					this.shareLinkedin()
					break;
				case "google":
					this.shareGoogleplus()
					break;
				case "pinterest":
					this.sharePinterest();
					break;
			}
		});
	}

	open(href, width, height) {
		if (this.w) {
			this.w.close();
		}

		this.w = window.open(href, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,channelmode=no,fullscreen=no,width=' + width + ',height=' + height);
	}

	getTargetSocialClass(target){
		for(var i in target.classList) {
			let c = target.classList[i];
			if(c !== 'ui' && c !== 'button') {
				return c;
			}
		}

		return null;
	}

	//Google+
	shareGoogleplus() {
		this.open("//plus.google.com/share?url={0}".format(this.meta.currentUrl), 680, 450);
	}

	//LINKEDIN
	shareLinkedin() {
		this.open("//www.linkedin.com/cws/share?url={0}".format(this.meta.currentUrl), 560, 320);
	}

	//TWITTER
	shareTwitterX() {
		var twitterString = this.meta.oneliner;
		var metaLength = (" via " + this.meta.twitterUsername).length + 23;
		if (twitterString.length + metaLength > 140) {
			twitterString = twitterString.substring(0, 140 - (metaLength + 5)) + "...";
		}

		this.open("//twitter.com/intent/tweet?original_referer={0}&source=tweetbutton&via={2}&url={0}"
		.format(this.meta.currentUrl, encodeURIComponent(twitterString), encodeURIComponent(this.meta.twitterUsername)), 560, 320);
	}

	//FACBOOK
	shareFacebook() {
		this.open("//www.facebook.com/sharer/sharer.php?u={0}".format(this.meta.currentUrl), 560, 320);
	}

	sharePinterest() {
		this.open("//pinterest.com/pin/create/link/?url={0}&description={1}".format(this.meta.currentUrl, this.meta.description), 900, 400);

	}

}

// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
	String.prototype.format = function() {
		var args = arguments;
		return this.replace(/{(\d+)}/g, function(match, number) {
			return typeof args[number] != 'undefined'
				? args[number]
				: match
				;
		});
	};
}

export default SocialPanel;